import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import AppWrapper from './App';
import AlexaLoginPage from './pages/AlexaLoginPage';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';

// console.log('[Boot] CRA starting. NODE_ENV=', process.env.NODE_ENV);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* If the path is /alexa-login, render ONLY the login page */}
        <Route path="/alexa-login" element={<AlexaLoginPage />} />
        
        {/* For all other paths, render the full application */}
        <Route path="/*" element={<AppWrapper />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// Register service worker for offline app shell caching
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
